<div *ngIf="formGroup && selectedTenant">
  <form style="padding-bottom: 2em" [formGroup]="formGroup" formFocusable>
    <app-feedback-card [originalModel]="gridRegistration" [formGroup]="formGroup"></app-feedback-card>

    <app-default-card
      spyTarget="hinweis"
      [title]="'Interne Informationen'"
      [info]="''"
      [showThisComponent]="isAdminUser"
      [showChildComponent]="true">
      <app-internal-information [inputForm]="formGroup"></app-internal-information>
    </app-default-card>

    <app-default-card
      spyTarget="anschlussobjekt"
      [title]="'Anschlussobjekt'"
      [info]="''"
      [showThisComponent]="true"
      [showChildComponent]="true"
      [error]="
        (formGroup.get('connectionObject').get('streetNo').invalid && errorFormList.length > 0) ||
        !isAreaTypeAvailableInObjectAddress
      "
      [errorMessage]="'Anschlussadresse ist erforderlich'">
      <app-select-gis-data
        [areaType]="areaType"
        [disable]="disable"
        [inputForm]="formGroup"
        [inputFormAdditionalInfo]="formGroup.get('additionalInfoConnectionObject')"
        [isLoaded]="technician"
        [listDevelopmentAreas]="listDevelopmentAreas"
        [showGetGisData]="showGetGisData"
        [selectedGisData]="selectedGisData"
        [selectedCompanyLocation]="selectedCompanyLocation"
        [isAdminUser]="isAdminUser"
        [errorFormList]="errorFormList"
        [state]="gridRegistration.state"
        [companyLocationsBytenant]="companyLocationsBytenant"
        [eventsFromParent]="eventsToGis"
        (resetCompanyLocation)="resetCompanyLocation()"
        (onSelectedGisData)="changeGisData($event)"></app-select-gis-data>
    </app-default-card>

    <app-default-card
      spyTarget="eigentuemer"
      *ngIf="isAreaTypeAvailableInObjectAddress"
      [title]="'Hauseigentümer'"
      [info]="'Bitte geben Sie hier die Kontaktdaten des Hauseigentümers an.'"
      [showThisComponent]="companyLocationsBytenant"
      [showChildComponent]="companyLocationsBytenant">
      <app-filiation-form
        [inputFormArray]="formGroup.controls['filiationData']"
        [id]="gridRegistration?.id"
        [selectedGisData]="selectedGisData"
        [disableContractPartner]="true"></app-filiation-form>
    </app-default-card>

    <app-hint-card
      *ngIf="
        gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer &&
        ('gridRegistration.PlugInProducer.producerSectionHint' | uiAdaptionVisible$ | async)
      "
      [type]="'info'"
      [outlined]="true"
      [constrainToPage]="true">
      <div
        [innerHTML]="
          'gridRegistration.PlugInProducer.producerSectionHint' | uiAdaptionValue | safeHtmlPipe
        "></div>
    </app-hint-card>

    <app-default-card
      spyTarget="artdererzeugungsanlage"
      *ngIf="gridRegistrationType == gridRegistrationTypeEnum.Feeder"
      [title]="'Art der Erzeugungsanlage'"
      [info]="''"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-grid-registration-type
        [inputForm]="formGroup"
        [disableAllFields]="disableAllFields"
        (selectedPVModule)="selectedPVModule($event)"></app-grid-registration-type>
    </app-default-card>

    <app-default-card
      spyTarget="bedingungenmesskonzept"
      *ngIf="gridRegistrationType == gridRegistrationTypeEnum.Feeder"
      [title]="'Messkonzept'"
      [info]="'Bitte wählen Sie hier das von Ihnen geplante Messkonzept aus.'"
      [showThisComponent]="gridRegistrationType == gridRegistrationTypeEnum.Feeder"
      [showChildComponent]="true"
      [error]="
        errorFormList.length > 0 && !formGroup.get('meteringConcept') && !selectedMeteringConceptToShow
      ">
      <app-display-and-select-option
        [columns]="3"
        [article]="'ein'"
        [title]="'Messkonzept'"
        [canUpdate]="!disableAllFields && canUpdate"
        [options]="meteringListToShow"
        [selectedOption]="selectedMeteringConceptToShow"
        (onSelectedOptionChanged)="selectedGridRegistrationType($event)"></app-display-and-select-option>
    </app-default-card>

    <!-- WENN PV => DANN (WECHSELRICHTER) -->
    <app-default-card
      spyTarget="erzeugungseinheiten"
      *ngIf="
        gridRegistrationType == gridRegistrationTypeEnum.Feeder ||
        gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer
      "
      [title]="'Erzeugungseinheiten'"
      [info]="''"
      [showThisComponent]="
        gridRegistrationType == gridRegistrationTypeEnum.Feeder ||
        gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer
      "
      [showChildComponent]="true">
      <app-grid-registration-producer
        *ngIf="
          formGroup &&
          gridRegistrationType &&
          (gridRegistrationType == gridRegistrationTypeEnum.Feeder ||
            gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer)
        "
        (inverterChanges)="producerChangesDetection()"
        [inputForm]="formGroup"
        [gridRegistrationType]="gridRegistrationType"
        [isAdminUser]="isAdminUser"
        [error]="
          !hasPvModule &&
          totalPowerProducers >= dataShareService.tenantConfig.gridRegistration.vde4105UpperLimit
        "
        [documentRequired]="documentRequired"
        [hasPVModule]="hasPvModule"
        (totalPowerChanges)="totalPowerChanges($event)"
        [inputFormArray]="formGroup.controls['producers']"
        [disable]="disableAllFields"></app-grid-registration-producer>
    </app-default-card>

    <app-default-card
      spyTarget="verbraucher"
      [title]="'Verbraucher'"
      [info]="''"
      [showThisComponent]="
        gridRegistrationType == gridRegistrationTypeEnum.Charger ||
        gridRegistrationType == gridRegistrationTypeEnum.EHeating ||
        gridRegistrationType == gridRegistrationTypeEnum.Misc
      "
      [showChildComponent]="true">
      <app-grid-registration-consumer
        *ngIf="
          gridRegistrationType == gridRegistrationTypeEnum.Charger ||
          gridRegistrationType == gridRegistrationTypeEnum.EHeating ||
          gridRegistrationType == gridRegistrationTypeEnum.Misc
        "
        (inverterChanges)="consumerChangesDetection()"
        [gridRegistrationType]="gridRegistrationType"
        [inputFormArray]="formGroup.controls['consumers']"
        [currentForm]="formGroup"
        [maxExtractionPower]="maxExtractionPower"
        [disable]="disableAllFields"></app-grid-registration-consumer>
    </app-default-card>

    <app-default-card
      spyTarget="pv_module"
      *ngIf="
        gridRegistrationType == gridRegistrationTypeEnum.Feeder ||
        gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer
      "
      [title]="'PV-Module'"
      [info]="''"
      [showThisComponent]="
        (gridRegistrationType == gridRegistrationTypeEnum.Feeder &&
          formGroup.get('powerGenerationSource').value == feederTypeEnum.PhotoVoltaic) ||
        gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer
      "
      [showChildComponent]="true">
      <app-grid-registration-pv-module
        *ngIf="
          (gridRegistrationType == gridRegistrationTypeEnum.Feeder &&
            formGroup.get('powerGenerationSource').value == feederTypeEnum.PhotoVoltaic) ||
          gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer
        "
        [listInverterDevices]="listInverterDevices"
        [error]="
          hasPvModule &&
          totalPowerPVModules >= dataShareService.tenantConfig.gridRegistration.vde4105UpperLimit
        "
        [gridRegistrationType]="gridRegistrationType"
        [disable]="disableAllFields"
        (totalPVPowerChanges)="totalPowerPVModulesChanges($event)"
        [inputFormArray]="formGroup.controls['pvModules']"></app-grid-registration-pv-module>
    </app-default-card>

    <app-default-card
      spyTarget="einspeiser-management"
      *ngIf="
        selectedCompanyLocation &&
        gridRegistrationType == gridRegistrationTypeEnum.Feeder &&
        ((totalPowerPVModules > 0 &&
          totalPowerPVModules < dataShareService.tenantConfig.gridRegistration.vde4105UpperLimit &&
          hasPvModule) ||
          (totalPowerProducers > 0 &&
            totalPowerProducers < dataShareService.tenantConfig.gridRegistration.vde4105UpperLimit &&
            !hasPvModule))
      "
      [title]=""
      [info]="''"
      [showThisComponent]="gridRegistrationType == gridRegistrationTypeEnum.Feeder"
      [showChildComponent]="true">
      <app-grid-registration-feedin-management-info
        [error]="errorFormList.length > 0 && !formGroup.get('feedInManagementInfo').value"
        [hasPvModule]="hasPvModule"
        [selectedCompanyLocation]="selectedCompanyLocation"
        [inputForm]="formGroup"
        [totalPowerProducers]="
          hasPvModule ? totalPowerPVModules : totalPowerProducers
        "></app-grid-registration-feedin-management-info>
    </app-default-card>

    <app-default-card
      spyTarget="speicher"
      *ngIf="gridRegistrationType == gridRegistrationTypeEnum.Feeder"
      [title]="'Speicher'"
      [info]="''"
      [showThisComponent]="gridRegistrationType == gridRegistrationTypeEnum.Feeder"
      [showChildComponent]="gridRegistrationType == gridRegistrationTypeEnum.Feeder">
      <app-grid-registration-storage
        *ngIf="gridRegistrationType == gridRegistrationTypeEnum.Feeder"
        [hasPowerInverter]="hasPowerInverter"
        [selectedStorageConceptToShow]="selectedStorageConceptToShow"
        [storageListToShow]="storageListToShow"
        [canUpdate]="canUpdate"
        [inputForm]="formGroup"
        [inputFormArray]="formGroup.controls['storages']"
        [disable]="disableAllFields"
        (isHasStorage)="isHasStorage($event)"
        (isSelectedOption)="isSelectedStorageConcept($event)"></app-grid-registration-storage>
    </app-default-card>

    <app-default-card
      spyTarget="weitere_informationen_netzanschluss"
      *ngIf="
        isAreaTypeAvailableInObjectAddress &&
        gridRegistrationType != gridRegistrationTypeEnum.PlugInProducer &&
        !(hideAdditionalGridConnectionPointInformationCard$ | async)
      "
      [title]="'Weitere Informationen zum Netzanschluss'"
      [info]="'Hier können Sie uns noch weitere wichtigen Informationen zu Ihrem Netzanschluss mitteilen'"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-grid-registration-more-info
        [inputForm]="formGroup"
        [gridRegistrationType]="gridRegistrationType"
        [disabledAllFields]="disableAllFields"
        [inputFormFreeMoreInformation]="formGroup"
        (hasInstalledDevices)="hasInstalledDevices($event)"></app-grid-registration-more-info>
    </app-default-card>

    <app-default-card
      spyTarget="dokumente"
      *ngIf="
        isAreaTypeAvailableInObjectAddress && gridRegistrationType != gridRegistrationTypeEnum.PlugInProducer
      "
      [title]="'Dokumente'"
      [info]="''"
      [showThisComponent]="formGroup.controls['uploads']"
      [showChildComponent]="true">
      <app-upload-documents
        *ngIf="gridRegistrationType != gridRegistrationTypeEnum.PlugInProducer"
        [inputFormArray]="formGroup.controls['uploads']"
        [documentTag]="documentTagEnum.gridRegistrationDoc"
        [showTag]="false"
        [canUpdate]="canUpdate"
        [filterCriteria]="compareEnum.equal"
        [numberOfUploads]="10"
        [editUpload]="isAdminUser || gridRegistration.state == gridRegistrationStatusEnum.Incomplete"
        [showUploadButton]="
          isAdminUser ||
          gridRegistration.state == gridRegistrationStatusEnum.Approved ||
          gridRegistration.state == gridRegistrationStatusEnum.Requested ||
          gridRegistration.state == gridRegistrationStatusEnum.Incomplete ||
          gridRegistration.state == gridRegistrationStatusEnum.FeedbackNeeded
        "
        (uploaded)="uploadDocument($event)">
        <div *ngIf="!isAdminUser">
          <p>
            Bitte laden Sie uns hier die relevanten technischen Dokumentationen hoch.
            <br />
            z.B. Datenblätter der verbauten Komponenten, Zertifikate und einen einpoligen
            Übersichtsschaltplan.
            <br />
          </p>
        </div>
        <div *ngIf="isAdminUser">
          <p>
            Relevante technische Dokumentationen.
            <br />
            z.B. Datenblätter der verbauten Komponenten, Zertifikate und einen einpoligen
            Übersichtsschaltplan.
            <br />
          </p>
        </div>
      </app-upload-documents>
    </app-default-card>

    <app-default-card
      spyTarget="bedingungen"
      *ngIf="isAreaTypeAvailableInObjectAddress"
      [title]="
        gridRegistrationType != gridRegistrationTypeEnum.PlugInProducer
          ? 'Bedingungen'
          : 'Zählernummer und Bedingungen'
      "
      [info]="''"
      [showThisComponent]="companyLocationsBytenant"
      [showChildComponent]="companyLocationsBytenant">
      <div class="wrapper" *ngIf="gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer">
        <div class="col" fxFlex="100">
          <mat-form-field appearance="outline" fxFlex="95">
            <mat-label>Zählernummer</mat-label>
            <input matInput type="text" maxlength="90" formControlName="meterNumber" />
          </mat-form-field>
        </div>
      </div>

      <form-row>
        <mat-form-field appearance="outline">
          <mat-label>Datum der Inbetriebnahme</mat-label>
          <input
            matInput
            formControlName="placeInServiceDatum"
            [matDatepicker]="placeInServiceDatum"
            placeholder="Datum der EEG-Technischen Inbetriebnahme:" />
          <mat-datepicker-toggle matSuffix [for]="placeInServiceDatum"></mat-datepicker-toggle>
          <mat-datepicker #placeInServiceDatum></mat-datepicker>
          <mat-error
            *ngIf="
              !formGroup.get('placeInServiceDatum').valid && formGroup.get('placeInServiceDatum').touched
            ">
            Fehler
          </mat-error>
        </mat-form-field>
      </form-row>

      <form-row
        *ngIf="
          gridRegistrationType == gridRegistrationTypeEnum.PlugInProducer &&
          ('gridRegistration.PlugInProducer.conditionsCheckbox' | uiAdaptionVisible$ | async)
        ">
        <mat-checkbox
          [formControl]="customConditionsCheckbox"
          [disabled]="disableConditions || disableAllFields">
          <div
            [innerHTML]="
              'gridRegistration.PlugInProducer.conditionsCheckbox' | uiAdaptionValue | safeHtmlPipe
            "></div>
        </mat-checkbox>
      </form-row>
      <mat-error *ngIf="customConditionsCheckbox.touched && customConditionsCheckbox.invalid">
        Bitte akzeptieren Sie alle Bedingungen
      </mat-error>

      <app-accept-conditions
        *ngIf="gridRegistrationType != gridRegistrationTypeEnum.PlugInProducer"
        [inputForm]="formGroup.controls['acceptConditions']"
        [controlName]="'ownerConsent'"
        [disable]="disableConditions"
        [inputLink]=""
        [inputText]="
          'Hiermit bestätige ich, dass die Zustimmung des Eigentümers vorliegt.'
        "></app-accept-conditions>
    </app-default-card>
  </form>
</div>
